export const MINUTE = 60 * 1000;
export const HOUR = 60 * MINUTE;
export const MAX_DELAY = HOUR;

export const RESPONDS_REPORT_HANDLE = {
  //source: 'Отклик из',
  vacancy: "На вакансию",
  phone: "Телефон",
  name: "Имя",
  city: "Город",
  //ts: 'Поступил',
  //sent_ts: 'Отправлен',
};

export const MICRO_RESPONDS = ["avito", "sources"];
